var Pixel = Pixel || {};

Pixel.Adwords = (function (PixelBase) {
	var Adwords = PixelBase.extend({
		initialize: function (opts) {
			opts = opts || {};
			this._currency = opts.currency;
			this._settings = opts.settings;
			this._labels = _.extend({
				regView: null,
				regSuccess: null,
				purchaseSuccess: null
			}, opts.labels);
		},

        registrationView: function () {
        	this._track(this._labels.regView);
        },

        registrationSuccess: function () {
        	this._track(this._labels.regSuccess);
        },

        purchaseSuccess: function (opts) {
        	opts = opts || {};
        	this._track(this._labels.purchaseSuccess, {
            	google_custom_params: _.omit(opts, 'OrderInfoResult'),
            	google_conversion_value: opts.totalValue || 0.0,
            	google_conversion_currency: opts.currency || this._currency
        	});
        },

        _getAPI: function () {
            return this._api || window.google_trackConversion;
        },

        _track: function(label, additionalParams) {
        	this._getAPI()(_.extend(this._settings, {
            	google_conversion_label: label
            }, additionalParams || {}));
        }
    });

    return Adwords;
})(Pixel.PixelBase);

!function ($, Pixel, GlobalSettings) {
    if (!GlobalSettings.GAE) {
        return;
    }

    $.getScript('//www.googleadservices.com/pagead/conversion_async.js', function () {
        new Pixel.Adwords({
			settings: {
				google_conversion_id: GlobalSettings.GAI,
				google_conversion_format: GlobalSettings.GAF,
				google_conversion_language: 'en',
				google_conversion_color: 'ffffff',
				google_remarketing_only: false,
			},

			labels: {
				regView: GlobalSettings.GARL,
				regSuccess: GlobalSettings.CASL,
				purchaseSuccess: GlobalSettings.GACL
			},

			currency: GlobalSettings.Currency
        });
    });
}(jQuery, Pixel, app.GlobalSettings);
